import { render, staticRenderFns } from "./SendEmailDialog.vue?vue&type=template&id=58bb2a6e&scoped=true&lang=pug&"
import script from "./SendEmailDialog.vue?vue&type=script&lang=js&"
export * from "./SendEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailDialog.vue?vue&type=style&index=0&id=58bb2a6e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb2a6e",
  null
  
)

export default component.exports